import "./ProductCard.css"
import { Row, Col, Card, Button } from "react-bootstrap";
import { Rating } from "react-simple-star-rating";
import { LinkContainer } from "react-router-bootstrap";

export default function ProductCard(props) {
  // displays product details including name, rating, description, price, instock
  // provides link to more detailed product page

  if (!props.product) {
    return;
  }
  return (
    <Col className="card-container" >
      <Card style={{border:"none",   }}>
        <Row>
          <Col xs={4} sm={12}>
          <LinkContainer className="pointer" to={`/product-details/${props.product?._id}`}>
            <Card.Img
              className="card-image"
              style={{ height: "200px", objectFit: "contain", overflow: "hidden" }}
              variant="top"
              src={props.product?.images[0]?.url}
            />
            </LinkContainer>
          </Col> 
          <Col xs={8} sm={12}>
            {" "}
            <Card.Body>
              <Card.Title>{props.product?.name}</Card.Title>
              <Rating
                  className="mb-2"
                  readonly
                  size={20}
                  allowFraction={true}
                  initialValue={props.product?.rating || 0}
                />
                ({props.product?.nrOfReviews || 0})
              <Card.Text className="card-description text-block">
                {props.product?.description}
              </Card.Text>
              <Card.Text>
                <span className="h4">
                  {props.product?.price?.toLocaleString("en-CA", {
                    style: "currency",
                    currency: "CAD",
                  })}
                </span>{" "}
                <span className="mt-2" style={{ fontSize: "small", display:"inline" }}>
                {props.product.inventoryCount > 0 ? (
                  <i style={{ color: "green" }} className="bi bi-check2-circle">
                    {" "}
                    In stock
                  </i>
                ) : (
                  <i
                    style={{ color: "red" }}
                    className="bi bi-exclamation-circle"
                  >
                    {" "}
                    Sold out
                  </i>
                )}
              </span>
              </Card.Text>
              <LinkContainer to={`/product-details/${props.product?._id}`}>
                <Button variant="primary">Shop Now</Button>
              </LinkContainer>
            </Card.Body>
          </Col>
        </Row>
      </Card>
    </Col>
  );
}
